// extracted by mini-css-extract-plugin
module.exports = {"backToTopWrapper":"oX","button":"oY"};